
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightEmergency as ObiLightEmergencyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-emergency.js';
 
 
 

 
 export const ObiLightEmergency = createComponent({
   react: React,
   tagName: 'obi-light-emergency',
   elementClass: ObiLightEmergencyElement,
   events: {
     
   }
  });
 
 